import { getData, postData } from "../../api";

export const getAllData = async (
  page,
  per_page,
  search,
  name,
  from,
  to,
  state_id,
  city_id,
  type,
) => {
  try {
    let url = `/payment/outward-payment?`;

    if (page) {
      url += `&page=${page}`;
    }

    if (per_page) {
      url += `&per_page=${per_page}`;
    }
    if (search) {
      url += `&term=${search}`;
    }
    if (name) {
      url += `&name=${name}`;
    }

    if (from) {
      url += `&from=${from}`;
    }

    if (to) {
      url += `&to=${to}`;
    }
    if (state_id) {
      url += `&state_id=${state_id}`;
    }
    if (city_id) {
      url += `&city_id=${city_id}`;
    }
    if (type) {
      url += `&type=${type}`;
    }

    return await getData(url);
  } catch (error) {
    console.error(error);
  }
};

export const getAllReportsData = async (
  page,
  per_page,
  search,
  name,
  from,
  to,
  state_id,
  city_id,
  type,
) => {
  try {
    let url = `/payment/outward-payment/reports?`;

    if (page) {
      url += `&page=${page}`;
    }

    if (per_page) {
      url += `&per_page=${per_page}`;
    }

    if (search) {
      url += `&term=${search}`;
    }
    if (name) {
      url += `&name=${name}`;
    }

    if (from) {
      url += `&from=${from}`;
    }

    if (to) {
      url += `&to=${to}`;
    }
    if (state_id) {
      url += `&state_id=${state_id}`;
    }
    if (city_id) {
      url += `&city_id=${city_id}`;
    }
    if (type) {
      url += `&type=${type}`;
    }

    return await getData(url);
  } catch (error) {
    console.error(error);
  }
};

export const OutwardAccepted = async (data) => {
  try {
    return await postData(`/payment/outward-payment/accepted`, data);
  } catch (error) {
    console.error(error);
  }
};

export const OutwardRejected = async (data) => {
  try {
    return await postData(`/payment/outward-payment/rejected`, data);
  } catch (error) {
    console.error(error);
  }
};

export const OutwardMultiple = async (data) => {
  try {
    return await postData(`/payment/outward-payment/multiple`, data);
  } catch (error) {
    console.error(error);
  }
};

export const BulkOutward = async (data) => {
  try {
    return await postData(`/payment/outward-payment/bulk-outward`, data);
  } catch (error) {
    console.error(error);
  }
};

export const AcceptBulkOutward = async (data) => {
  try {
    return await postData(`/payment/outward-payment/accept-bulk-outward`, data);
  } catch (error) {
    console.error(error);
  }
};
